import React, { FC, IframeHTMLAttributes } from 'react';

import { cn } from '../../../../utils';

import './IFrame.scoped.scss';

interface Props extends IframeHTMLAttributes<HTMLIFrameElement> {
  title?: string;
}

const IFrame: FC<Props> = ({ title = 'Document preview', ...props }) => {
  return <iframe {...props} className={cn('document-preview', props.className)} title={title} />;
};

export default IFrame;
